import React from "react"
import { DataPrivacy } from "./components/data-privacy"
import { Accesibility } from "./components/accesibility"
import { Analytics } from "./components/analytics"
import { useId } from "../hooks/use-id";

/**
 * El componente EdTechStandard representa una página o sección relacionada con "Estándares Abiertos para Integraciones en EdTech".
 * Incluye diferentes secciones como "Privacidad de Datos", "Accesibilidad WGCA" y "Analíticas".
 *
 * @component
 * @example
 * // Uso del componente EdTechStandard
 * <EdTechStandard />
 *
 * @returns {JSX.Element} - El componente EdTechStandard.
 */

export const EdTechStandard = () => {
    const dataPrivacyId =useId('data-privacy');
    const accessibilityId =useId('accessibility');

    return (
        <>
            <div className="main-container background--bg" lang="en">
                <div className="surface--bg onbackground-primary--color container main-content px-3 pb-5 p-lg-5"  style={{minHeight:'100vh'}}>
                    <div className="pb-5">
                        <h1 className="text-center mb-5">OPEN STANDARD FOR EDTECH INTEGRATIONS</h1>
                        <div className="px-2 px-lg-5">
                            <section className="mb-4" aria-labelledby={dataPrivacyId}>
                                <h2 className="subseccion-politica mb-2" style={{border:'none', outline:'none'}} id={dataPrivacyId}>Data Privacy</h2>
                                <DataPrivacy/>
                            </section>
                            <section className="mb-4 w-100" aria-labelledby={accessibilityId}>
                                <div className="d-flex flex-wrap align-items-center my-3">
                                    <div className="col-12 col-lg-6 px-0">
                                        <h2 className="subseccion-politica" style={{border:'none', outline:'none'}} id={accessibilityId}>Accessibility WGCA</h2>
                                    </div>
                                    <div className="col-12 col-lg-6 px-0">
                                        <div className="d-flex justify-content-lg-end mt-3 mt-lg-0">
                                            <a
                                                href="/document/vpat2_5rev_wcag_makemake_feb_2026.pdf"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="primary-button-var2 py-2 mr-3 focusable-red"
                                                aria-label="Download VPAT document 2024 (PDF, opens in new tab)"
                                                lang="en"
                                            >
                                                Product VPAT
                                             2024</a>
                                            <a 
                                                href="/document/vpta2_5_rev_wcag_makemake_abri_l2026.pdf" 
                                                target="_blank" 
                                                rel="noopener noreferrer" 
                                                className="primary-button-var2 py-2 focusable-red"
                                                aria-label="Download VPAT document 2026 (PDF, opens in new tab)"
                                                lang="en"
                                            >Product VPAT 2026</a>
                                        </div>

                                    </div>
                                </div>
                               <Accesibility/>
                            </section>
                            {/* <div className="mb-4">
                                <h2 tabIndex={0} className="focusable-secondary subseccion-politica mb-2" style={{border:'none', outline:'none'}}>Analytics</h2>
                               <Analytics/>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}